document.addEventListener('DOMContentLoaded', () => {
  const $form = document.querySelector('#js-bra-calculator-form');
  if (!$form) return;

  const $bandInput = document.querySelector('#js-bra-calculator-band-input');
  const $bustInput = document.querySelector('#js-bra-calculator-bust-input');
  const $bandErrorField = document.querySelector('#js-bra-calculator-band-error');
  const $bustErrorField = document.querySelector('#js-bra-calculator-bust-error');
  const $sizeField = document.querySelector('#js-bra-calculator-size');
  const $resultField = document.querySelector('#js-bra-calculator-result');
  const $resultLink = document.querySelector('#js-bra-calculator-result-link');
  const $resetBtn = document.querySelector('#js-bra-calculator-reset');

  $form.addEventListener('submit', event => {
    event.preventDefault();

    // Reset previous state
    $bandInput.parentElement.classList.remove('has-error');
    $bustInput.parentElement.classList.remove('has-error');
    $resultField.classList.remove('is-visible');
    $form.classList.remove('is-hidden');
    $bandErrorField.innerHTML = '';
    $bustErrorField.innerHTML = '';
    $sizeField.innerHTML = '';

    const bandSize = Number($bandInput?.value);
    const bustSize = Number($bustInput?.value);
    const bandErrors = validateBand(bandSize);
    const bustErrors = validateBust(bustSize, bandSize);

    if (bandErrors.length > 0) {
      $bandInput.parentElement.classList.add('has-error');
      $bandErrorField.innerText = getErrorMessage(bandErrors[0]);
      return;
    }

    if (bustErrors.length > 0) {
      $bustInput.parentElement.classList.add('has-error');
      $bustErrorField.innerText = getErrorMessage(bustErrors[0]);
      return;
    }

    const [band, cup] = generateSize(bandSize, bustSize);

    $resultLink.href += `?constraint=${$resultLink.dataset.bandParam}-${band}+${$resultLink.dataset.cupParam}-${cup}`;
    $sizeField.innerText = `${band}${cup}`;
    $resultField.classList.add('is-visible');
    $form.classList.add('is-hidden');
  });

  $resetBtn?.addEventListener('click', () => {
    $bandInput.parentElement.classList.remove('has-error');
    $bustInput.parentElement.classList.remove('has-error');
    $resultField.classList.remove('is-visible');
    $form.classList.remove('is-hidden');
    $bandErrorField.innerHTML = '';
    $bustErrorField.innerHTML = '';
    $sizeField.innerHTML = '';
  });

  function validateBand(value) {
    return v8n().number().positive().testAll(value);
  }

  function validateBust(value, min) {
    return v8n().number().positive().greaterThan(min).lessThanOrEqual(min + 12).testAll(value);
  }

  function getErrorMessage(error) {
    switch (error.rule.name) {
      case 'number':
      case 'positive':
        return 'Value must be a positive number.';
      case 'greaterThan':
        return 'Bust size must be larger than band size.';
      case 'lessThanOrEqual':
        return 'Bust size must be within 12 inches of band size.';
      default:
        return 'This field has an error.';
    }
  }

  function generateSize(band, bust) {
    const cups = ['A', 'B', 'C', 'D', 'DD or E', 'DDD or F', 'G', 'H', 'I', 'J', 'K', 'L'];
    const index = bust - band;

    if (band % 2 === 1) {
      band++;
    }

    return [band, cups[index - 1]];
  }
});
